import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import 'bootstrap/dist/css/bootstrap.css';
import './css/main.css';
import './css/navigation.css';
import './css/loader.css';
import './css/datepicker.css';

import 'react-tooltip-component-16/lib/tooltip.css';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { AuthProvider } from './auth/authContext';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');


ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <AuthProvider>
            {/* <StrictMode> */}
            <App />
            {/* </StrictMode> */}
        </AuthProvider>
    </BrowserRouter>,
    rootElement);

//registerServiceWorker();
unregisterServiceWorker();